var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductSmartform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 40,
    height: 48,
    rx: 9,
    stroke: "#DADADA",
    strokeWidth: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 22H35",
    stroke: "#DADADA",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 34H29",
    stroke: "#DADADA",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 51L46 60L68 34",
    stroke: "url(#smartFormGradient)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "smartFormGradient",
    x1: 37,
    y1: 51,
    x2: 68,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7948AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49B7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSmartform);
export default __webpack_public_path__ + "static/media/product_smartform.e4cad03ca5e034c0edf5b7fa7f696015.svg";
export { ForwardRef as ReactComponent };